module.exports = __webpack_public_path__ + "img/chart-2.ba0b70e4.svg";